import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { useTranslation } from "react-i18next";
// Import privileges utility
import { hasPrivilege } from "../utils/privileges_utility";

function PaperComponent(props) {
  return (
    <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const useStyles = makeStyles(theme => ({
  disabledIcon: {
    opacity: 0.5,
    cursor: 'not-allowed'
  }
}));

export default function ConfirmDialog(props) {
  const [t, i18n] = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  
  // Check if user has delete privilege
  const canDelete = hasPrivilege("DOC_TEMP_DEL");

  const handleClickOpen = () => {
    // If user doesn't have permission, show notification instead of opening dialog
    if (!canDelete) {
      const response = {
        status: "ERROR",
        message: "You don't have permission to delete templates",
      };
      props.dialogResultCallBack(response);
      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOK = recordId => {
    setOpen(false);
    const response = {
      status: "SUCCESS",
      data: recordId
    };
    props.dialogResultCallBack(response);
  };

  const handleCancel = recordId => {
    setOpen(false);
    const response = {
      status: "CANCELLED",
      data: null
    };
    props.dialogResultCallBack(response);
  };

  return (
    <div>
      {canDelete ? (
        <Tooltip title="Delete" placement="top">
          <IconButton
            aria-label="delete"
            color="secondary"
            size="small"
            onClick={handleClickOpen}
          >
            <DeleteIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Delete (Requires permission)" placement="top">
          <span className={classes.disabledIcon}>
            <IconButton
              aria-label="delete"
              color="secondary"
              size="small"
              disabled={true}
            >
              <DeleteIcon fontSize="inherit" />
            </IconButton>
          </span>
        </Tooltip>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {t("Confirm delete")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("Are you sure you want to delete this record?")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCancel} color="secondary">
            {t("CANCEL")}
          </Button>
          <Button
            onClick={event => {
              handleOK(props.recordId);
            }}
            color="primary"
          >
            {t("OK")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}